module.exports = __webpack_public_path__ + "static/people_pop7-11e3bfeb1be69b7c54165d072c2dea95.png";